<template>
  <card>
     <template slot="header">
        <h3 class="card-title">NTE Tracker</h3>
     </template>
           <nav class="row">
              <ol class="breadcrumb arr-right bg-breadcrum">
                 <li class="breadcrumb-item">
                    <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                 </li>
                 <li class="breadcrumb-item">
                    <router-link to="/hr/employeelist">Active Employees</router-link>
                 </li>
                 <li class="breadcrumb-item">
                    <router-link to="/hr/resigned">Inactive Employees</router-link>
                 </li>
                 <li class="breadcrumb-item">
                    <router-link to="/hr/dependents">Dependents</router-link>
                 </li>
                 <li class="breadcrumb-item">
                    <router-link to="/hr/workshifts">Workshifts</router-link>
                 </li>
                 <!-- NEW ADDITIONAL -->
                 <li class="breadcrumb-item">
                    <router-link to="/hr/scheduleadjustment">Schedule Adjustment</router-link>
                 </li>
                 <li class="breadcrumb-item">
                    <router-link to="/hr/undertimerequest">Undertime Request</router-link>
                 </li>
                 <li class="breadcrumb-item active">NTE Tracker</li>
                 <li class="breadcrumb-item">
                    <router-link to="/hr/coaching/records">Employee Coached</router-link>
                  </li>
              </ol>
           </nav>
           <hr style="margin-top:-10px" />
     <div class="row"> 
       <div class="col-md-8"></div>
        <div class="col-md-4">
           <span class="float-md-right">
            <router-link to="/hr/nterequestform" class="btn btn-primary"><i class="fa fa-plus"></i>&nbsp;NTE Tracker</router-link>
            <router-link to="/hr/ntemanualinput" class="btn btn-primary"><i class="fa fa-plus"></i>&nbsp;Encode NTE Manually</router-link>
           </span>
        </div>
     </div>
     <hr/>
     <div class="col-md-12">
        <div class="row">
           <div class="col-md-5">
              <p><i class="fa fa-search"></i> Search Employee</p>
              <input type="test" v-model="search" class="form-control" placeholder="Search...">
           </div>
           <div class="col-md-2">
            <p><i class="fa fa-filter"></i> Filter By Year</p>
             <select v-model="filter_by_year" @change="getYear" class="form-control" required>
               <option v-for="year in years(2019)">{{ year }}</option>
             </select>
          </div>
           <div class="col-md-1">
              <div class="form-group">
                 <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                 <select v-model="page_limit" class="form-control" required>
                    <option value="">Default</option>
                    <option value="2">2</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                 </select>
              </div>
           </div>
           <div class="col-md-2">
              <div class="form-group">
                 <p><i class="fa fa-filter"></i>&nbsp;Filter by Status:</p>
                 <select v-model="filter_by_status" class="form-control" required>
                    <option value="">Default</option>
                    <option value="pending">pending</option>
                    <option value="approved">approved</option>
                    <option value="rejected">rejected</option>
                 </select>
              </div>
           </div>
           <div class="col-md-2">
              <div class="form-group">
                 <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                 <select v-model="order_by" class="form-control" required>
                    <option value="">Default</option>
                    <option value="1">ASC</option>
                    <option value="-1">DESC</option>
                 </select>
              </div>
           </div>
        </div>
     </div>
     <hr>
      <!-- PAGINATION -->
      <b-pagination
      v-model="curentPage"
      :total-rows="items.length"
      :per-page="perPage"
       aria-controls="my-table"
       align="right"
       first-text="First"
       prev-text="Prev"
       next-text="Next"
       last-text="Last"
      ></b-pagination>
      <!-- END PAGINATION -->
      <hr>
     <div class="table-responsive ">
        <table class="table table-striped table-hover " v-loading="loading">
           <thead>
              <tr>
                 <th></th>
                 <th width="650">Requested By</th>
                 <th width="850">Infraction</th>
                 <th>Status</th>
                 <th width="280">ACTION</th>
                 
                 <th width="200">Date Request</th>
                 <th width="15">Remove</th>
              </tr>
           </thead>
           <tbody>
              <tr v-for="item,index in computedRequest">
                 <template v-if="item === 'no data found'">
                    <td colspan="100%">
                       <h4><i class="fa fa-database"></i> Empty Records ...</h4>
                    </td>
                 </template>
                 <template v-else>
                    <td>
                       <span v-if="item.employee_status === 'unacknowledged'">
                       <i class="fa fa-flag text-danger" v-b-tooltip.hover title="Waiting for agent to approve this request."></i>
                       </span>
                       <span v-else>
                       <i class="fa fa-flag text-success"></i>
                       </span>
                    </td>
                    <td>
                       <span v-if="item.hr_status === 'pending'">
                          <b>
                             <template v-if="item.requested_by.length < 16">{{ item.requested_by }}</template>
                             <template v-if="item.requested_by.length >= 16">{{ item.requested_by.substring(0,16)+"..." }}</template>
                          </b>
                          - Requested NTE to 
                          <b>
                             <template v-if="item.full_name.length < 20">{{ item.full_name }}</template>
                             <template v-if="item.full_name.length >= 20">{{ item.full_name.substring(0,20)+"..." }}</template>
                          </b>
                       </span>
                       <span v-else class="text-fade">
                          <template v-if="item.requested_by.length < 16">{{ item.requested_by }}</template>
                          <template v-if="item.requested_by.length >= 16">{{ item.requested_by.substring(0,16)+"..." }}</template>
                          - Requested NTE to 
                          <template v-if="item.full_name.length < 20">{{ item.full_name }}</template>
                          <template v-if="item.full_name.length >= 20">{{ item.full_name.substring(0,20)+"..." }}</template>
                       </span>
                    </td>
                    <td>
                       <span v-if="item.hr_status === 'pending'">
                          <b>
                             <template v-if="item.details_of_infraction.length < 79">{{ item.details_of_infraction }}</template>
                             <template v-if="item.details_of_infraction.length >= 79">{{ item.details_of_infraction.substring(0,79)+"..." }}</template>
                          </b>
                       </span>
                       <span v-else class="text-fade">
                          <template v-if="item.details_of_infraction.length < 79">{{ item.details_of_infraction }}</template>
                          <template v-if="item.details_of_infraction.length >= 79">{{ item.details_of_infraction.substring(0,79)+"..." }}</template>
                       </span>
                    </td>
                    <td>
                       <span v-if="item.hr_status === 'pending'">
                       <button class="pending">Pending</button>
                       </span>
                       <span v-else-if="item.hr_status === 'approved'"> 
                       <button class="approved ">Approved</button>
                       </span>
                       <span v-else-if="item.hr_status === 'rejected'"> 
                       <button class="rejected">Rejected</button>
                       </span>
                    </td>
                    <td>
                      <span v-if="(item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.hr_status === 'approved')  && item.employee_status == 'unacknowledged'">
                          <router-link :to="{name: 'nte-edit-request', params: { id: item.id }}" class="r-link"  ><i class="fa fa-pencil"></i>Update Request</router-link>
                      </span> 
                       <span v-if="(item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.hr_status === 'approved')  && item.employee_status == 'acknowledged' && item.hr_decision_status == 'undecided'">
                          <router-link :to="{name: 'notice-for-decision', params: { id: item.id }}" class="r-link"  >Notice of Decision</router-link>
                       </span>
                       <span v-if="(item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.hr_status === 'approved')  && item.employee_status == 'acknowledged' && item.hr_decision_status == 'decided'">
                          <router-link :to="{name: 'nte-view-details', params: { id: item.id }}" class="r-link"  ><i class="fa fa-eye"></i>&nbsp;View Details</router-link>
                       </span>
                       <span v-if="(item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.hr_status === 'pending')">
                          <router-link :to="{name: 'nte-approval-request', params: { id: item.id }}" class="r-link" ><i class="fa fa-mail-forward"></i>Review request</router-link>&nbsp;&nbsp;<span class="badge badge-danger">New</span>
                       </span>
                       <span v-if="(item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.hr_status === 'rejected')">
                          <router-link :to="{name: 'nte-approval-request', params: { id: item.id }}" class="r-link" ><i class="fa fa-mail-forward"></i>Update request</router-link>
                       </span>
                    </td>
                   
                    <td>
                       <span v-if="item.hr_status === 'pending'">
                       <i class="fa fa-calendar"></i>&nbsp;<b>{{getDate(item.date_request)}}</b>
                       </span>
                       <span v-else class="text-fade">
                       <i class="fa fa-calendar"></i>&nbsp;{{getDate(item.date_request)}}
                       </span>
                    </td>
                     <td><button class="btn btn-danger btn-xs btn-circle" @click = "deleteItem(item.id, index)" v-b-tooltip.hover title="Remove NTE Request"><i class="fa fa-times"></i></button></td>
                 </template>
              </tr>
           </tbody>
        </table><br/>
        <!-- PAGINATION NATIVE WAY -->
          <div class="row">
              <div class="col-md-6">
                  <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
              </div>
              <div class="col-md-6">
                <b-pagination
                    v-model="curentPage"
                    :total-rows="items.length"
                    :per-page="perPage"
                    aria-controls="my-table"
                    align="right"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                ></b-pagination>
              </div>
           </div>
           <!-- END PAGINATION -->
           <!-- If Lost Connection on Server -->   
       <template v-if="display_indicator === 1">
        <center>
           <br/><br/>
           <img  src="/static/img/warning.png"  width="225" height="190">
           <h1>You've lost your network connection</h1>
           <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
           <br/><br/>
        </center>
     </template>
     </div>
  </card>
</template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
components: {
Card,
},

data() {
   return {
      items: [],
      selected_user: '',
      selected: {},
      leave_status: '',
      order_by: '',
      filter_by_status: '',
      filter_by_type: '',
      filter_by_year:'',
      //FILTER
      page_limit: '',
      start_page: 1,
      loading: true,
      search: '',
      //Indicator
      display_indicator: '',
      //PAGINATION
      perPage: 200,
      curentPage: 1
      }
},

created: function () {
this.get_employees();
},

methods: {
  deleteItem(id, index) {

     /* USING SWEET ALERT */
        this.$swal({
            title: 'Are you sure?',
            text: 'You can\'t revert your action',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes Delete it!',
            cancelButtonText: 'No, Keep it!',
            showCloseButton: false,
            showLoaderOnConfirm: true
          })
          .then((isConfirm) => {
            if (isConfirm === true) {
               axios.delete('api/nterequest/delete/' + id)
                 .then(response => {
                   this.get_employees(); // reloader 
                   this.$swal('Deleted', 'You successfully deleted this file', 'success')
                })
                .catch(response => {
                  //alert("error");
                  console.log(response);
                  this.$swal('Error Code', 'Review your code', 'error')
                });
            }
          });
      },

    getYear(){
      if(this.filter_by_year == ''){
        this.get_employees()
      }else{
        axios.get('api/nterequestbyhr/' + this.filter_by_year)
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error.response)
        });
      } 
    },

    get_employees() {
    axios.get('api/nterequestbyhr')
      .then(response => {
        this.items = response.data
        this.loading = false
        this.display_indicator = 2;
      })
      .catch(error => {
        console.log(error.response)
        this.display_indicator = 1;
      });
    }
    },
    computed: {
    offset() {
       return (this.start_page - 1) * this.page_limit;
    },
    limit() {
      return this.offset + this.page_limit;
    },
    total_item() {
       return this.items.length
    },

    computedRequest() {
    let filtered = this.items
    // USE IN PAGINATION 
    let start = (this.curentPage - 1) * this.perPage
    let end = this.curentPage * this.perPage
    filtered = filtered.slice(start, end)

    if (filtered.length > 0) {
      // SEARCH BY EMPLOYEE FULLNAME  
      if (this.search) {
        filtered = filtered.filter(
          item => item.full_name.toLowerCase().indexOf(this.search) > -1
        );
        return filtered
      }
      // SORTING NUMBER OF DISPLAY
      if (this.page_limit) {
        filtered = filtered.slice(this.offset, this.limit);
        return filtered
      }
      // FILTER BY STATUS
      if (this.filter_by_status) {
        filtered = filtered.filter(
          item => item.hr_status.toLowerCase() === this.filter_by_status.toLowerCase()
        );
        return filtered
      }
      // ORDER BY ASC AND DESC COMBOBOX
      if (this.order_by) {
        filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
        return filtered
      }
    } else {
      filtered = 0
    }

    return filtered
    }
    },

}
</script>





// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-nte-request.vue